import React, { useState } from 'react';
import { useIntl } from "react-intl";

const BlockNumber = ({ msisdn, onMsisdnChange, onBlockClick ,isInvalid,isDisabled }) => {
  const intl = useIntl();
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  const handleBlock = async () => {
      const response = await onBlockClick();

      if (response && response.error) {
          setMessage(response.data.response[0].message);
          setMessageType('error');
      } else if (response && response.data) {
          setMessage(response.data.response[0].message);
          setMessageType(response.data.code==0 ? 'success' : 'error');
      }

      setTimeout(() => {
          setMessage('');
          setMessageType('');
      }, 4000);
  };

    return (
          <div className="mobile-container">
            <label className="mobile-label"> {intl.formatMessage({ id: "AUTH.MOBILE" })} (+ {intl.formatMessage({ id: "ECOMMERCE.COMMON.CCode" })})</label>
            <input
                type="text"
                value={msisdn}
                onChange={onMsisdnChange}
                className={`mobile-input ${isInvalid ? 'invalid-input' : ''}`}
                placeholder="e.g. 964750xxx xxxx"
                maxLength={21}
            />
            <ul className="mobile-rules">
                <li>{intl.formatMessage({ id: "CHAT.MUST1" })}</li>
                <li>{intl.formatMessage({ id: "CHAT.MUST2" })}</li>
                <li>{intl.formatMessage({ id: "CHAT.MUST3" })}</li>
            </ul>
            <button className="mobile-button" onClick={handleBlock} disabled={isDisabled} > {intl.formatMessage({ id: "CHAT.BLOCK" })}</button>
            {message && (
                <div className={`response-message ${messageType}`}>
                    {message}
                </div>
            )}
            </div>
    );
};

export default BlockNumber;